import request from "@/util/axios";

// 共享变量
var _hw_h5_order_tmp_ = {};

var get_hw_h5_order = function (tradeno) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append("tradeno", tradeno);

    // 查询待支付订单信息 主要是金额 orderFee
    request.post("/mall/hw-h5-order-get", formData).then((res) => {
      budo_log.info("#35 hw-h5-order-get, res=", res);

      if (res && res.data) {
        _hw_h5_order_tmp_ = res.data;
        resolve(res.data);
        return;
      }

      reject("hw-h5-order-get err");
    });
  });
};

var hw_h5_order_info_for_pay = function (cards) {
  budo_log.info("#26 _hw_h5_order_tmp_=", _hw_h5_order_tmp_, "cards=", cards);

  _hw_h5_order_tmp_.cardList = JSON.parse(JSON.stringify(cards));
  _hw_h5_order_tmp_.cardList.forEach((e) => {
    e.cardUseType = e.useType;
    e.quantity = e.useQuantity; // 这张卡使用了多少
  });

  _hw_h5_order_tmp_.goodsList = [];

  _hw_h5_order_tmp_.cardMoney = _hw_h5_order_tmp_.cardList
    .map((e) => e.quantity)
    .reduce((sum, quantity) => sum + quantity, 0);
  _hw_h5_order_tmp_.wxPayFee =
    _hw_h5_order_tmp_.orderFee - _hw_h5_order_tmp_.cardMoney;

  _hw_h5_order_tmp_.orderType = "HW_H5";

  return _hw_h5_order_tmp_;
};

export { get_hw_h5_order, hw_h5_order_info_for_pay };
